"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cn = require("classnames");
const React = require("react");
const Icon = ({ icon, ...rest }) => (React.createElement("span", Object.assign({}, rest),
    React.createElement("i", { className: cn({ fa: /fa-/i.test(icon) }, icon) })));
exports.default = Icon;
//# sourceMappingURL=index.js.map